import { Decoration_Type } from 'ricos-schema';
import { Mark_Type } from 'ricos-types';

const findMarkColor = (marks, type) => {
  var _a, _b;
  return (_b = (_a = marks.find((mark) => mark.type === type)) == null ? void 0 : _a.attrs) == null ? void 0 : _b.color;
};
const getColorMark = (color, type) => color ? { type, attrs: { color } } : void 0;
const isDefined = (x) => x !== void 0;
const colorConverter = {
  fromTiptap: {
    types: [Mark_Type.COLOR_BACKGROUND, Mark_Type.COLOR_FOREGROUND],
    convert: (marks) => ({
      type: Decoration_Type.COLOR,
      colorData: {
        background: findMarkColor(marks, Mark_Type.COLOR_BACKGROUND),
        foreground: findMarkColor(marks, Mark_Type.COLOR_FOREGROUND)
      }
    })
  },
  toTiptap: {
    types: [Decoration_Type.COLOR],
    convert: ({ colorData }) => [
      getColorMark(colorData == null ? void 0 : colorData.background, Mark_Type.COLOR_BACKGROUND),
      getColorMark(colorData == null ? void 0 : colorData.foreground, Mark_Type.COLOR_FOREGROUND)
    ].filter(isDefined)
  }
};

export { colorConverter };
//# sourceMappingURL=color-converter.js.map
